import { useGlobalGroupsData } from "@/data/use-global-groups-data";
import { Select, SelectContent, SelectItem, SelectTrigger } from "../ui/select";

type GroupSelectionProps = {
  groupUuid: string | null | undefined;
  hideGroupUuid?: string;
  onChange: (groupUuid: string) => void;
};

export const GroupSelect: React.FC<GroupSelectionProps> = ({
  groupUuid,
  hideGroupUuid,
  onChange,
}) => {
  const { groups } = useGlobalGroupsData();
  const selectedGroupName = groups.find((w) => w.uuid === groupUuid)?.name;
  const filteredGroups = hideGroupUuid
    ? groups.filter((w) => w.uuid !== hideGroupUuid)
    : groups;

  const handleGroupChange = (groupUuid: string) => {
    onChange(groupUuid);
  };

  return (
    <Select value={groupUuid ?? undefined} onValueChange={handleGroupChange}>
      <SelectTrigger>{selectedGroupName ?? "No group"}</SelectTrigger>
      <SelectContent>
        {filteredGroups.map((group) => (
          <SelectItem key={group.uuid} value={group.uuid}>
            {group.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
